// 4993 A6 — project selector label (WIT-GAP-FLEX-4993-002 §7 A6, D-FLEX-10 display exception).
//
// The timer API aliases Weldit's columns as number = project no., po_name =
// project title, name = AO number. With the new `customer_name` the label
// becomes "number - po_name - customer" (AO dropped). An older API without the
// field keeps today's string exactly, trailing separator included.

export function projectLabel (project) {
  if (!project || typeof project !== 'object') return ''
  const customer = typeof project.customer_name === 'string' ? project.customer_name.trim() : ''
  if (customer) {
    const parts = []
    if (project.number) parts.push(project.number)
    if (project.po_name) parts.push(project.po_name)
    parts.push(customer)
    return parts.join(' - ')
  }
  let projectName = ''
  projectName += project.number ? `${project.number} - ` : ''
  projectName += project.po_name ? `${project.po_name} - ` : ''
  projectName += project.name ? project.name : ''
  return projectName
}
